<template>
  <div>
   
    <v-card-title>
      <h2>Package Archaive Details</h2>
      <v-spacer></v-spacer>

      <v-btn class="mx-0" color="info" title="Download" @click="downloadFIle">
        <v-icon color="white">cloud_download</v-icon>
      </v-btn>  

      <v-btn color="error" @click="previous" title="Back">
          <v-icon>arrow_back_ios</v-icon>Back
        </v-btn>

    </v-card-title>

    <table width="100%" class="tblClass">
      <tbody>     
        <tr>
          <th colspan="4" style="font-weight:bold; font-size:20px; padding:10px 0px;">Package Details</th>
        </tr>
        <tr>
          <th>Project Name</th>
          <td colspan="3" style="font-weight:bold; padding-left:8px;">{{packagesList.project_name}}</td>
        </tr>
        <tr>
          <td colspan="4">&nbsp;</td>
        </tr>

        <tr class="textCenter">          
          <th>Version Number.</th>
          <th>Version Date.</th> 
          <th>Package Name</th> 
          <th>Package Number</th> 
        </tr>

        <tr class="textCenter">          
          <td>{{packagesList.version_no}}</td>
          <td>{{(packagesList.versioning_date) ? changeFormateDMY(packagesList.versioning_date) : ''}}</td>
          <td>{{packagesList.name}}</td>
          <td>{{packagesList.package_no}}</td>
        </tr>


        <tr class="textCenter">
          <th>From Date</th> 
          <th>To date</th>
          <th>Procurement Type</th> 
          <th>Unit</th> 
        </tr>
        <tr class="textCenter">
          <td>{{(packagesList.from_date) ? changeFormateDMY(packagesList.from_date) : ''}}</td>
          <td>{{(packagesList.to_date) ? changeFormateDMY(packagesList.to_date) : ''}}</td>
          <td>{{packagesList.pro_type_name}}</td>
          <td>{{packagesList.unit_name}}</td>
        </tr>


        <tr class="textCenter">
          <th>Beneficiary Name</th> 
          <th>Quantity Lot</th>
          <th>Quantity</th> 
          <th>Method</th> 
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.beneficiary_name}}</td>
          <td>{{packagesList.quantity_lot}}</td>
          <td>{{packagesList.quantity}}</td>
          <td>{{packagesList.method_name + ' ( '+ packagesList.market_approach + ' )' }}</td>
        </tr>

        <!-- <tr class="textCenter">
          <th>Estimated Price</th> 
          <th>Es Currency</th>
          <th>Es Currency Rate</th> 
          <th>Estimated bdt</th> 
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.estimated_price}}</td>
          <td>{{packagesList.es_currency}}</td>
          <td>{{packagesList.es_currency_rate}}</td>
          <td>{{packagesList.estimated_bdt}}</td>
        </tr>

        <tr class="textCenter">
          <th>Actual Cost</th> 
          <th>Actual Currency</th>
          <th>Actual Currency Rate</th> 
          <th>Actual bdt</th> 
        </tr>
        <tr class="textCenter">
          <td>{{(packagesList.actual_cost) ? packagesList.actual_cost : '&nbsp;'}}</td>
          <td>{{packagesList.actual_currency}}</td>
          <td>{{packagesList.ac_currency_rate}}</td>
          <td>{{packagesList.actual_bdt}}</td>
        </tr> -->

        <tr class="textCenter">
          <th>Contract Type</th> 
          <th>Revision Date</th>
          <th>Delivery Date</th> 
          <th>Prior Rev</th> 
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.contract_type_name}}</td>
          <td>{{(packagesList.revision_date) ? changeFormateDMY(packagesList.revision_date) : ''}}</td>
          <td>{{(packagesList.delivery_date) ? changeFormateDMY(packagesList.delivery_date) : ''}}</td>
          <td>{{packagesList.prior_rev == 0 ? 'No' : 'Yes'}}</td>
        </tr>

        <tr class="textCenter">
          <th>Meeting No</th> 
          <th>Reference Package</th>
          <th>Status</th> 
          <th>Remarks</th> 
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.meeting_no}}</td>
          <td>{{packagesList.referenc_package_id}}</td>
          <td>{{satusName(packagesList.status_id)}}</td>
          <td>{{packagesList.remarks}}</td>
        </tr>  

        <tr class="textCenter">
          <th>Estimated Price</th>
          <th>Actual Cost</th>          
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.estimated_price | currency}}</td>
          <td>{{(packagesList.actual_cost) ? packagesList.actual_cost : '&nbsp;'}}</td>
        </tr>      

      </tbody>
    </table>
    <br><br>

    <table width="100%" class="tblClass">
      <tbody>
        <tr>
          <th colspan="3" style="font-weight:bold; font-size:20px; padding:10px 0px;">Economic Code</th>
        </tr>
        <tr>
          <th>Eco Code</th>
          <th>Eco Code Name</th>
          <th>Amount</th>
        </tr>
        <tr v-for="item in packagesEcoList" class="textCenter">
          <td>{{item.eco_account_code}}</td>
          <td>{{item.eco_code}}</td>
          <td>{{item.amount | currency}}</td>
        <tr>
        </tr>
      </tbody>      
    </table>
    <br><br>


    <table width="100%" class="tblClass">
      <tbody>
        <tr>
          <th colspan="6" style="font-weight:bold; font-size:20px; padding:10px 0px;">Package Steps</th>
        </tr>
        <tr>
          <th>Step Name</th>
          <th>Tentative Start Date</th>
          <th>Total Days</th>
          <th>Tentative End Date</th>
          <th>Remarks</th>
          <th>Tentative Value</th>
        </tr>
        <tr v-for="item in executionList" class="textCenter">
          <td>{{item.step_name}}</td>          
          <td>{{(item.start_date) ? changeFormateDMY(item.start_date) : ''}}</td>
          <td>{{item.tentative_total_days}}</td>          
          <td>{{(item.end_date) ? changeFormateDMY(item.end_date) : ''}}</td>
          <td>{{item.remarks}}</td>
          <td>{{item.actual_value}}</td>
        <tr>
        </tr>
      </tbody>      
    </table>

  </div>
</template>


<script>
const commonService = require("../../../../services/common.service");
import Axios from "axios";
import ServerPath from '../../../../server-path/server-path';

export default {

  data: () => ({
    valid: true,    

     queryData2: {
      packageId: "",
      versionNo:""
    },

    packagesList:[],
    packagesEcoList:[],
    executionList:[],    

  }),

  created() {
    let query_Data2 = this.queryData2;
        
        (query_Data2.packageId = sessionStorage.getItem("pacId")),
        (query_Data2.versionNo = sessionStorage.getItem("pacVersionId"));          

        commonService.getServerSideData(query_Data2, "package-version-details")
        .then(res => {
          this.packagesList = res.packagesList;
          this.packagesEcoList = res.packagesEcoList;
          this.executionList = res.executionList;
        })   
  },

  
  methods: {

    satusName(statusId){
    let status_list = [
      { id: "1", name: "Plan" },
      { id: "2", name: "Execute" },
      { id: "3", name: "Revision" },
      { id: "4", name: "Merge" },
      { id: "5", name: "Split" },
      { id: "6", name: "Close" },
      { id: "7", name: "Terminate" },
      { id: "8", name: "Procured" },
    ];
    if (statusId) {
      return status_list.filter(function(a) {
        return a.id == statusId;
      })[0].name;
      
      //console.log('status_list', status_list)
    }

    },

    downloadFIle(){

      let query_Data2 = this.queryData2;
        
        (query_Data2.packageId = sessionStorage.getItem("pacId")),
        (query_Data2.versionNo = sessionStorage.getItem("pacVersionId"));

      let parameters = new URLSearchParams({ ...query_Data2}).toString();
      let route = ServerPath.serverPath+'/archive-pdf?'+parameters;
      window.open(route, '_blank');
    },

    previous(){
      this.$router.push('/procurement/archive-list') 
    }
  }
};
</script>

<style scoped>
.tblClass{
  border-collapse: collapse;
}
.tblClass tr th,
.tblClass tr td{
  border:1px solid #CCC;
  padding:8px 0px;
}
.textCenter tr th,
.textCenter tr td,
.textCenter{
  text-align: center;  
}
</style>


// WEBPACK FOOTER //
// src/components/procurement/package_archive/details/dataTable.vue